import { Controller } from 'stimulus';

class VacancyAlertController extends Controller {
  connect() {
    this.isHidden = false;
  }

  onToggleClick() {
    this.isHidden = !this.isHidden;

    this.toggle();
  }

  toggle() {
    this.element.classList.toggle('is-hidden', this.isHidden);
  }
}

VacancyAlertController.targets = [];

export default VacancyAlertController;
